import "../App.css";
//import "./home.css";
import moment from "moment";
import TodoBasket from "./TodoBasket";
import React, { useState, useEffect } from "react";
import { LoadingPage } from "../loading/LoadingPage";
import { NavigationBar } from "../navigation/NavigationBar";

import { Pagination } from "../paging/Pagination";

import { useParams, Link } from "react-router-dom";
import { call, home, addBasket } from "../service/ApiService";

import { AddBasket } from "../pay/Proxy";
import {
  Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";

export function BasketList() {
  // pays?basket=402880828b0fce5b018b0fcebef80000
  const params = new URLSearchParams(window.location.search);
  let parampage = params.get("page");
  let message = params.get("message");

  //console.log("basket :" + basket);
  //pays({ basket: basket });

  const [items, setItems] = useState([]);
  const [pages, setPages] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const size = 10;
  let limit = size;

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/basket/list?size=" + size + "&page=" + pages, "GET").then(
      (response) => {
        // console.log(response);
        if (!response) {
          console.log("결과값 없음.");
          //alert("연결이 안되어 메인페이지로 이동합니다.");
          //alert("누구냐 넌 : " + "정체를 밝혀라.");
          //window.location.href = "/home";
          return;
        }

        if (response.error) {
          if (
            response.error === "jwtout" &&
            window.confirm(
              "로그인이 만료되었습니다. 로그인페이지로 이동할까요?"
            )
          ) {
            window.location.href = "/login";
          } else {
            console.log("메시지 : " + response.error);
            window.location.href = "/home";
          }
        }

        if (response.data) {
          setItems(response.data);
          setTotalPage(Math.floor((response.data.length - 1) / size) + 1);
        }
        //결제완료시
        if (message && message === "success_payed") {
          alert("결제 완료 ");
          window.close();
          window.location.href = "/basketList";
        } else if (message && message === "failed_payment") {
          alert("결제 되지 않았습니다. 창을 닫고 다시 접속해 주시기 바랍니다.");
          window.close();
          window.location.href = "/basketList";
        } else if (message && message === "failed_itemAmount") {
          alert("결제 되지 않았습니다. 재고가 부족합니다.");
          window.close();
          window.location.href = "/basketList";
        }
      }
    );
  }, []);

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;

  /* 선택한 content 렌더링 */
  //{"welcomt Home!"}

  /*
  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행

    addBasket().then((response) => {
      console.log(response);
      if (response) {
        alert("장바구니 담기.");
        //반환값이 없을경우
        console.log(response.data);
        //setPutbasket(putbasket+1);
        //window.location.href = response.data;
      } else if (!response) {
        // 반환값이 없을경우
        alert("장바구니 안 담겼어요.");
        //if (window.confirm("로그인 필요합니다. 로그인 하시겠습니까?")) {
        // alert("로그인에 실패하였습니다.가입정보를 확인하여 다시 로그인 해주세요.");
        //window.location.href = "/login";
        //} else {
        //const navigate = useNavigate();
        //navigate(-1);
        // onCancel();
        //}
      } else {
        alert(" 실패.");
        //window.location.href = "/login";
      }
    });
  }, []);
  */

  let home = "Welcome Home!";

  let subject = "장바구니 리스트";
  let navigationBar = NavigationBar(subject);

  //<Checkbox checked={item.done} onChange={checkboxEventHandler} />

  let menu = (
    <Paper style={{ margin: 16 }}>
      <List className="menu">
        <div>{"Menu"}</div>
        <ListItem>
          <Link to="/home" variant="1">
            상위단계 home
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>상위 단계로 이동.</ListItemSecondaryAction>
        </ListItem>
      </List>
    </Paper>
  );

  items.map((item) => {
    if (moment(item.createdAt).isValid()) {
      item.createdAt = moment(item.createdAt).format("YYYY-MM-DD");
    } else {
      //item.createdAt = moment().format("YYYY-MM-DD");
      item.createdAt = moment("2000-01-01", "YYYY-MM-DD").format("YYYY-MM-DD");
    }
  });

  const editItem = (item) => {
    if (!item.count) {
      alert("상품갯수가 비어있습니다.");
      //item.count = 1;
      //console.log(item.count);
      return;
    }
    if (!window.confirm("수량 " + item.count + "개로 변경하시겠습니까?")) {
      return;
    }

    let basketDTO = { id: item.id, count: item.count, itemId: item.itemId };

    call("/basket/update", "PUT", basketDTO).then((response) => {
      if (!response) {
        alert("연결이상입니다.");
      }

      if (response.error) {
        if (response.error === "ItemStorage is exceeded.") {
          alert("판매가능 개수 이상입니다.");
        } else {
          alert("장바구니가 수정되지 않았습니다.");
        }
        console.log("response.error : " + response.error);
        return;
      }

      if (response) {
        //setItems(response.data);
        alert("장바구니가 수정되었습니다.");
        window.location.href = "/basketList";
      }
    });
  };

  const deleteItem = (item) => {
    //console.log(item.count);
    if (!item.count) {
      alert("상품갯수가 비어있습니다.");
      //item.count = 1;
      return;
    }

    if (!window.confirm("해당 장바구니를 삭제할까요?")) {
      return;
    }

    let basketDTO = { id: item.id, useYn: "N", itemId: item.itemId };

    call("/basket/update", "PUT", basketDTO).then((response) => {
      if (!response) {
        alert("연결이 안되어 삭제처리가 안됩니다.");
      }

      if (response.error) {
        alert("오류입니다.");
        console.log("response.error : " + response.error);
        return;
      }

      if (response.data) {
        //setItems(response.data);
        console.log(response.data);
        alert("장바구니가 삭제되었습니다.");
        window.location.href = "/basketList";
      }
    });
  };

  const onDeleteClick = (item) => {
    //window.location.href = "?page=" + item;
    console.log(item);
  };

  let todoItems = items.length > 0 && (
    <div>
      <Paper style={{ margin: 16 }}>
        <List className="menu">
          <div>
            <table>
              <thead></thead>
              <tbody>
                <tr>
                  <th>상품이름</th>
                  <th>상품링크</th>
                  {/*  <th>장바구니 날짜</th>*/}
                  <th>갯수</th>
                  <th>총가격</th>
                  <th>결제</th>
                  <th>장바구니삭제</th>
                </tr>
                {items.map((item) => (
                  <tr item={item} key={item.id}>
                    <td>
                      {""}
                      <span>{item.itemName}</span>
                    </td>
                    <td>
                      <Link
                        to={"/viewItem?item=" + item.itemId /* */}
                        variant="1"
                      >
                        <Button>{" 링크 "}</Button>
                      </Link>
                    </td>
                    {/*
                    <td>
                      {""}
                      <span>{item.basketUpdatedAt}</span>
                    </td>
                  */}
                    <td>
                      {""}
                      <TodoBasket
                        item={item}
                        key={item.id}
                        editItem={editItem}
                        deleteItem={deleteItem}
                      />
                    </td>
                    <td>
                      {""}
                      <span>{item.count * item.itemPrice}</span>
                    </td>

                    <td>
                      {/* onClick={()=>{onPagingClick(item.id)}} pay는 post 장바구니 결제 pays는 get 장바구니 결제  */}
                      <Link to={"/pay?basket=" + item.id} variant="1">
                        <Button>{"장바구니 결제(현재는 pc에서만 됨)"}</Button>
                      </Link>
                    </td>
                    <td>
                      {""}
                      <IconButton
                        aria-label="Delete Basket"
                        onClick={() => {
                          deleteItem(item);
                        }}
                      >
                        <DeleteOutlined />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </List>
      </Paper>
    </div>
  );

  let paging = Pagination({ totalPage, limit, pages, setPages });
  if (items.length == 0) {
    paging = <div>없음.</div>;
  }
  /*
  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );

  */

  let content;
  /* 로딩중이 아닐 때 렌더링 할 부분 */
  let framePage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      <Container maxWidth="md">{menu}</Container>
      <Container maxWidth="md">{todoItems}</Container>
      <Container maxWidth="md">{paging}</Container>
    </div>
  );

  content = framePage;
  return <div className="App">{content}</div>;
}
